import { saveAs } from "file-saver";
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  AlignmentType,
} from "docx";

import formatNumberWithCommas from "../format/formatNumberWithCommas";
const borderColor = {
  top: { color: "FFFFFF" },
  bottom: { color: "FFFFFF" },
  left: { color: "FFFFFF" },
  right: { color: "FFFFFF" },
};
const inchesToTwentiethsOfAPoint = (inches) => {
  // 1 inch = 1440 twentieths of a point
  return Math.round(inches * 1440);
};

const handleDownloadBillDatas = async (billData, NameOfBill) => {
  const pageWidth = inchesToTwentiethsOfAPoint(2.84);
  const pageHeight = inchesToTwentiethsOfAPoint(11.69);
  const doc = new Document({
    sections: [
      {
        properties: {
          page: {
            size: {
              width: pageWidth,
              height: pageHeight,
            },
            orientation: "portrait", // "portrait" or "landscape"
            margin: {
              top: 0,
              right: 0,
              bottom: 1000,
              left: 0,
            },
          },
        },
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: `${billData.Brand}`,
                size: 35, // Add font size
              }),
            ],
            alignment: "center",
            spacing: { before: 200, after: 200 }, // Set spacing to 0
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: `${billData.Address}`,
                size: 18, // Add font size
              }),
            ],

            alignment: "center", // Center align the text
          }),
          new Paragraph({
            children: [new TextRun(`${billData.Phone}`)],
            alignment: "center", // Center align the text
            spacing: { before: 100, after: 100 },
          }),

          new Paragraph({
            children: [new TextRun(`${billData.Bill}`)],
            alignment: "center", // Center align the text
          }),

          new Paragraph({
            children: [new TextRun(`${billData.Line}`)],
            alignment: "center", // Center align the text
            spacing: { before: 100, after: 100 },
          }),

          // Table starts here
          new Table({
            width: { size: 90, type: "pct" }, // Adjust the width of the table
            borders: {
              top: { val: "none" },
              bottom: { val: "none" },
              left: { val: "none" },
              right: { val: "none" },
              insideH: { val: "none" }, // Remove inside horizontal borders
              insideV: { val: "none" },
            },
            alignment: AlignmentType.CENTER,

            rows: [
              // Header row
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        text: "Name",
                        spacing: { line: 360 },
                      }),
                    ],
                    width: { size: 30, type: "pct" },
                    borders: borderColor,
                  }),
                  new TableCell({
                    children: [
                      new Paragraph("Giá", { spacing: { line: 360 } }),
                    ], // Adjust spacing between lines
                    width: { size: 20, type: "pct" },
                    borders: borderColor,
                  }),
                  new TableCell({
                    children: [new Paragraph("SL", { spacing: { line: 360 } })], // Adjust spacing between lines
                    width: { size: 15, type: "pct" },
                    borders: borderColor,
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        text: "Tổng",
                        spacing: { line: 360 },
                        alignment: AlignmentType.RIGHT,
                      }),
                    ], // Adjust spacing between lines
                    width: { size: 10, type: "pct" },
                    borders: borderColor,
                  }),
                ],
              }),

              // Data rows
              ...billData.OrderList.map((item) => {
                const { name, price, totalItem, totalPrice } = item;
                return new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: name,
                          spacing: { line: 360 },
                        }),
                      ],
                      borders: borderColor,
                    }),

                    new TableCell({
                      children: [
                        new Paragraph({
                          text: formatNumberWithCommas(price).toString(),
                        }),
                      ],
                      borders: borderColor,
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: totalItem.toString(),
                        }),
                      ],
                      borders: borderColor,
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          text: formatNumberWithCommas(totalPrice).toString(),
                          alignment: AlignmentType.RIGHT,
                        }),
                      ],
                      alignment: AlignmentType.RIGHT,
                      borders: borderColor,
                      spacing: { line: 360 },
                    }),
                  ],
                });
              }),

              // Time row
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph("Thời gian")],
                    borders: borderColor,
                    // spacing: { line: 500 }
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        text: formatNumberWithCommas(
                          billData.PriceOfTime
                        ).toString(),
                        // spacing: { line: 500 },
                      }),
                    ],
                    borders: borderColor,
                  }),

                  new TableCell({
                    children: [
                      new Paragraph({
                        text: billData.TotalTime.toString(),
                        // spacing: { line: 500 },
                      }),
                    ],
                    borders: borderColor,
                  }),

                  new TableCell({
                    children: [
                      new Paragraph({
                        text: formatNumberWithCommas(
                          billData.PriceOfTotalTime
                        ).toString(),
                        alignment: AlignmentType.RIGHT,
                      }),
                    ],
                    alignment: AlignmentType.RIGHT,
                    borders: borderColor,
                  }),
                ],
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun(
                `Tổng Bill: ${formatNumberWithCommas(
                  billData.TotalPayment
                )} vnđ`
              ),
            ],
            alignment: "center", // Center align the text
            spacing: { before: 250 },
          }),
          new Paragraph({
            children: [new TextRun(`${billData.Date}`)],
            alignment: "center", // Center align the text
            spacing: { before: 100, after: 100 },
          }),
          new Paragraph({
            children: [
              new TextRun(`${billData.Debt !== "" ? billData.Debt : ""}`),
            ],
            alignment: "center", // Center align the text
          }),
          new Paragraph({
            children: [new TextRun(`${billData.Line}`)],
            alignment: "center", // Center align the text
            spacing: { before: 50, after: 100 },
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: `${billData.Goodbye}`,
                size: 18, // Add font size
              }),
            ],
            alignment: "center", // Center align the text
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: `${billData.SubGoodbye}`,
                size: 18, // Add font size
              }),
            ],
            alignment: "center", // Center align the text
          }),
        ],
      },
    ],
  });
  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `${NameOfBill}.docx`);
  });
};

export default handleDownloadBillDatas;
